import { NgModule } from '@angular/core';
import { LibConsentIconComponent } from './lib-consent-icon.component';

@NgModule({
  declarations: [LibConsentIconComponent],
  imports: [],
  exports: [LibConsentIconComponent],
})
export class LibConsentIconModule {}
